// import '@mdi/font/css/materialdesignicons.css'
// import '../public/fonts/fontawesome-pro-5.13.0-web/css/all.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
// import './assets/css/custom.css'

import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'

// import lodash from 'lodash'
// import moment from 'moment'
import router from './router'

// Vue.prototype.$lodash = lodash;
// Vue.prototype.$moment = moment;
Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')

